import {styled} from '@mui/material/styles'

// For Section Title previous styles 16px,600,24px
const SectionTitle = styled('div')(({theme}) => ({
  fontFamily: theme.typography.subtitleMedium.fontFamily,
  fontStyle: 'normal',
  fontWeight: theme.typography.labelLarge.fontWeight,
  fontSize: theme.typography.subtitleMedium.fontSize,
  lineHeight: theme.typography.subtitleMedium.lineHeight,
  marginTop: theme.spacing(2),
  color: theme.palette.hpBlack
}))

// For Input Title Normal and Italic previous styles 14px,400,19px

const InputTitleNormal = styled('div')(({theme}) => ({
  fontStyle: 'normal',
  color: theme.palette.hpBlack,
  marginLeft: theme.spacing(1)
}))

const InputTitleItalic = styled('div')(({theme}) => ({
  fontStyle: 'normal',
  color: theme.palette.hpBlack,
  margin: 0,
  marginBottom: '12px'
}))

export {InputTitleItalic, InputTitleNormal, SectionTitle}
